import api from '../../../api';

export type NodeHierarchy = {
  displayPrefix: boolean;
  id: string;
  prefix?: string;
  title: string;
};

export async function markModuleAsVisited(moduleId: string): Promise<void> {
  await api.put(`/studio/user/modules/${moduleId}/visited`);
}
